<template>
  <div>
    <input
      class="outlined"
      @input="search($event.target.value)"
      v-model="history_company_name"
      placeholder="History Company"
    />
    <div
      v-if="searchResult.length > 0 && searchResult[0] != undefined"
      class="search_results"
    >
      <div
        style="margin: 0;"
        :key="'history_company_' + (history_company == undefined ? '0' : history_company.id)"
        @click="selectHistoryCompany(history_company)"
        v-for="history_company in searchResult"
      >
        <div v-if="history_company != undefined" class="search_result is-flex is-align-items-center is-justify-content-space-between"
          :class="{ create_new_result: history_company.is_create }">
          <span v-if="history_company.is_create">צור חדש</span>
          <span v-else>{{ history_company.name }}</span>
          <span>{{ history_company.name }}</span>
          <div v-if="isCreating" class="loading"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'network-search-box',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    networkRequestName: {
      type: String,
      required: true
    },
    networkRequestBaseQuery: {
      type: Object,
      default: () => ({})
    },
    networkPostName: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      searchResult: [],
      history_company_name: this.value,
      isCreating: false
    }
  },
  methods: {
    search (keyword) {
      if (keyword.length == 0) {
        this.searchResult = []
        return
      }
      console.log(keyword)
      this.$network_utils[this.networkRequestName]({ ...this.networkRequestBaseQuery, name: keyword }).then(response => {
        this.searchResult = response
        this.searchResult.push({
          name: keyword,
          is_create: true,
          id: 0
        })
      })
    },
    selectHistoryCompany (history_company) {
      if (history_company.is_create) {
        this.createHistoryCompany(history_company)
        return
      }
      this.history_company_name = history_company.name
      this.searchResult = []
      this.$emit('input', history_company.id)
      this.$emit('selected', history_company)
    },
    createHistoryCompany (history_company) {
      this.isCreating = true
      this.$network_utils[this.networkPostName]({ name: history_company.name }).then((response) => {
        this.selectHistoryCompany(response)
        this.isCreating = false
      })
    }
  }
}
</script>
<style scoped>
  .create_new_result {
    color: white;
    background-color: var(--color-text);
  }
</style>
